import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './PackVerification.frontend.types'

@Injectable({ providedIn: 'root' })
export class PackVerification_cancel_verification_tasks_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { start_verification_task_id: number, license_plate_id: number, lot_id: number, packaging_id: number, quantity: number, serial_number_ids?: number[] }): Promise<{ reasons?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.start_verification_task_id)) {
      missingRequiredInParams.push('\'start_verification_task_id\'');
    }
    if (isNil(inParams.license_plate_id)) {
      missingRequiredInParams.push('\'license_plate_id\'');
    }
    if (isNil(inParams.lot_id)) {
      missingRequiredInParams.push('\'lot_id\'');
    }
    if (isNil(inParams.packaging_id)) {
      missingRequiredInParams.push('\'packaging_id\'');
    }
    if (isNil(inParams.quantity)) {
      missingRequiredInParams.push('\'quantity\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/functions/cancel_verification_tasks_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

